export default __webpack_public_path__ + "static/media/BOTTOM-P14-open-3mm.46f2843b.dwg";